import { Route, Routes } from 'react-router-dom';

import { ScreenLoaderBackdrop } from '@ocx/ui';
import { useOffers, OPTIMIZED_VOUCHERED_OFFERS_FILTER } from '@ocx/data-offers';

import { ReadyToUse } from './ReadyToUse';
import { ReadyToUseLayout } from './ReadyToUseLayout';
import { OfferDetailsController } from '../OfferDetails/offer-details.controller';
import { useGetNavigationActions } from '../../hooks/useGetNavigationActions';
import { AppRoutePath } from '../AppRoutePath';

export const ReadyToUseController = () => {
  const { offers, loading } = useOffers({
    variables: OPTIMIZED_VOUCHERED_OFFERS_FILTER,
  });
  const { pushToOfferDetails, pushToHome } = useGetNavigationActions();

  return (
    <ReadyToUseLayout onBackButtonClick={pushToHome}>
      <ScreenLoaderBackdrop open={loading} />
      <ReadyToUse offers={offers} getOfferOnClick={(offer) => () => pushToOfferDetails(offer.id)} loading={loading} />
      <Routes>
        <Route
          path={AppRoutePath.OfferDetails}
          element={<OfferDetailsController returnPath={AppRoutePath.ReadyToUseOffers} />}
        />
      </Routes>
    </ReadyToUseLayout>
  );
};

export default ReadyToUseController;
